module.exports = __webpack_public_path__ + "img/exposure_new.e4a8132d.gif";